<template>
  <div class='calendar-page-wrapper'>
    <h2>{{$t('message.appointment.title_appointmemt')}}
      <div class='views-wrapper d-none d-md-block'>
        <div class="form-group has-feedback has-search event-filt event-filt-input search-input">
          <span class="fa fa-search form-control-feedback" aria-hidden="true"></span>
          <input type="text" class="form-control" :placeholder="$t('message.appointment.filter_search')" v-model="filter_searchs">
        </div>
        
        <button type="button" @click="openNewAppointmentForm(true)" class="btn btn-success" v-if="$guser.isClinic() || $guser.isClinicMulti()">
          <i class="fa fa-plus"></i>
          {{$t('message.appointment.add_appointment')}}
        </button>

        <button v-if="filter_by_doctor" type="button" @click="openExportCriteria" class="btn btn-info">
          <i class="fa fa-file-o"></i>
          {{$t('message.appointment.export_appointments')}}
        </button>

        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" v-if="!filter_by_doctor" @click="switchView('daily')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': viewType === 'daily' }">
            <i class="fa fa-clock-o"></i>
            {{$t('message.appointment.daily_view')}}</button>
          <button type="button" @click="switchView('monthly')" class="btn btn-sq-border btn-sq" :class="{ 'btn-primary': viewType === 'monthly' }">
            <i class="fa fa-calendar"></i>
            {{$t('message.appointment.monthly_view')}}</button>
          <button v-if="filter_by_doctor" type="button" @click="switchView('weekly')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': viewType === 'weekly' }">
            <i class="fa fa-calendar"></i>
            {{$t('message.appointment.weekly_view')}}</button>
          <button type="button" @click="switchView('list')" class="btn btn-sq-border btn-sq-right" :class="{ 'btn-primary': viewType === 'list' }">
            <i class="fa fa-list"></i>
            {{$t('message.appointment.list_view')}}</button>
        </div>
      </div>
    </h2>


    <div class='time-wrapper d-none d-md-block'>
      <!--<div class="switch-time">
        <div class='switch-time-btn'>
          <div role="group" aria-label="Basic example" class="btn-group" v-show='!show_calendar_view'>
            <button type="button" @click="switchTime('all')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': filter_date_type === 'all' }">{{$t('message.appointment.filter_date_all')}}</button>
            <button type="button" @click="switchTime('range')" class="btn btn-sq-border btn-sq-right" :class="{ 'btn-primary': filter_date_type === 'range' }">{{$t('message.appointment.filter_date_range')}}</button>
          </div>
        </div>
        <div class='filter-date' v-show="filter_date_type === 'range' && !show_calendar_view">
          <flat-pickr v-model='filter_date_range' :placeholder="$t('message.appointment.filter_date_range_placeholder')" :config="{ mode: 'range' }" id='filter-date-range' :class="{ 'inactive': filter_date_type == 'all' }" class="flatpickr-input"/>
        </div>
      </div>-->
    </div>
    <div class='event-wrapper d-none d-md-block'>
      <div class='event-filters'>
        
        <!-- <multiselect id="filter_by_specialty"
                    class="multi-select-form event-filt"
                    v-model="filter_by_specialties" 
                    :placeholder="$t('message.appointment.filter_specialty')" 
                    :options="specialties" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label" v-if="$guser.isClinic() || $guser.isClinicMulti()"></multiselect> -->
        
        <div class='switch-time-btn event-filt'>
          <div role="group" aria-label="Basic example" class="btn-group" v-show='!show_calendar_view'>
            <button type="button" @click="switchTime('all')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': filter_date_type === 'all' }">{{$t('message.appointment.filter_date_all')}}</button>
            <button type="button" @click="switchTime('range')" class="btn btn-sq-border btn-sq-right" :class="{ 'btn-primary': filter_date_type === 'range' }">{{$t('message.appointment.filter_date_range')}}</button>
          </div>
        </div>
        <div class='filter-date event-filt' v-show="filter_date_type === 'range' && !show_calendar_view" >
          <flat-pickr v-model='filter_date_range' :placeholder="$t('message.appointment.filter_date_range_placeholder')" :config="{ mode: 'range' }" id='filter-date-range' :class="{ 'inactive': filter_date_type == 'all' }" class="flatpickr-input"/>
        </div>

        <multiselect id="filter_by_doctor"
                    class="multi-select-form event-filt"
                    v-model="filter_by_doctors" 
                    :placeholder="$t('message.appointment.filter_doctor')" 
                    :options="doctor_options" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    :loading="doctorLoading"
                    @search-change="getDoctorsOptions"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label" v-if="$guser.isClinic() || $guser.isClinicMulti()"></multiselect>

        <multiselect id="filter_by_clinic"
                    class="multi-select-form event-filt"
                    v-model="filter_by_clinics" 
                    :placeholder="$t('message.appointment.filter_clinic')" 
                    :options="clinic_options" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    :loading="clinicLoading"
                    @search-change="getClinicsOptions"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label" v-if="$guser.isDoctor()"></multiselect>

        <multiselect id="filter_by_status"
                    class="multi-select-form event-filt"
                    v-model="filter_by_status_list" 
                    :placeholder="$t('message.appointment.filter_status')" 
                    :options="status_options"
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>

      </div>
    </div>

    <div class="mobile-menu d-sm-block d-md-none">
      <div>
        <div class="form-group has-feedback has-search event-filt event-filt-input search-input">
          <span class="fa fa-search form-control-feedback" aria-hidden="true"></span>
          <input type="text" class="form-control" :placeholder="$t('message.appointment.filter_search')" v-model="filter_searchs">
        </div>
      </div>
      <div style="margin-bottom: 10px;">
        <button type="button" @click="openNewAppointmentForm(true)" class="btn btn-block btn-success" v-if="$guser.isClinic() || $guser.isClinicMulti()">
          <i class="fa fa-plus"></i>
          {{$t('message.appointment.add_appointment')}}
        </button>
      </div>
      <div>
        <button v-if="filter_by_doctor" type="button" @click="openExportCriteria" class="btn btn-block btn-info">
          <i class="fa fa-file-o"></i>
          {{$t('message.appointment.export_appointments')}}
        </button>
      </div>
      <div style="margin-bottom: 10px;">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" v-if="!filter_by_doctor" @click="switchView('daily')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': viewType === 'daily' }">
            <i class="fa fa-clock-o"></i>
            {{$t('message.appointment.daily_view')}}</button>
          <button type="button" @click="switchView('monthly')" class="btn btn-sq-border btn-sq" :class="{ 'btn-primary': viewType === 'monthly' }">
            <i class="fa fa-calendar"></i>
            {{$t('message.appointment.monthly_view')}}</button>
          <button v-if="filter_by_doctor" type="button" @click="switchView('weekly')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': viewType === 'weekly' }">
            <i class="fa fa-calendar"></i>
            {{$t('message.appointment.weekly_view')}}</button>
          <button type="button" @click="switchView('list')" class="btn btn-sq-border btn-sq-right" :class="{ 'btn-primary': viewType === 'list' }">
            <i class="fa fa-list"></i>
            {{$t('message.appointment.list_view')}}</button>
        </div>
      </div>
      <div>
        <div class='switch-time-btn event-filt'>
          <div role="group" aria-label="Basic example" class="btn-group" v-show='!show_calendar_view'>
            <button type="button" @click="switchTime('all')" class="btn btn-sq-border btn-sq-left" :class="{ 'btn-primary': filter_date_type === 'all' }">{{$t('message.appointment.filter_date_all')}}</button>
            <button type="button" @click="switchTime('range')" class="btn btn-sq-border btn-sq-right" :class="{ 'btn-primary': filter_date_type === 'range' }">{{$t('message.appointment.filter_date_range')}}</button>
          </div>
        </div>
      </div>
      <div>
        <div class='filter-date event-filt' v-show="filter_date_type === 'range' && !show_calendar_view" >
          <flat-pickr v-model='filter_date_range' :placeholder="$t('message.appointment.filter_date_range_placeholder')" :config="{ mode: 'range' }" id='filter-date-range' :class="{ 'inactive': filter_date_type == 'all' }" class="flatpickr-input"/>
        </div>
      </div>
      <div>
        <multiselect id="filter_by_doctor"
                    class="multi-select-form event-filt"
                    v-model="filter_by_doctors" 
                    :placeholder="$t('message.appointment.filter_doctor')" 
                    :options="doctor_options" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    :loading="doctorLoading"
                    @search-change="getDoctorsOptions"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label" v-if="$guser.isClinic() || $guser.isClinicMulti()"></multiselect>
      </div>
      <div>
        <multiselect id="filter_by_clinic"
                    class="multi-select-form event-filt"
                    v-model="filter_by_clinics" 
                    :placeholder="$t('message.appointment.filter_clinic')" 
                    :options="clinic_options" 
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    :loading="clinicLoading"
                    @search-change="getClinicsOptions"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label" v-if="$guser.isDoctor()"></multiselect>
      </div>
      <div>
        <multiselect id="filter_by_status"
                    class="multi-select-form event-filt"
                    v-model="filter_by_status_list" 
                    :placeholder="$t('message.appointment.filter_status')" 
                    :options="status_options"
                    :multiple="true"
                    :hide-selected="true"
                    :allow-empty="true" 
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
      </div>
    </div>

    <div class="row" v-if="show_calendar_view && calendarLoading" >
      <div class="offset-md-5 col-md-2">
        <dot-loader :loading="calendarLoading" size='60px'></dot-loader>
      </div>
    </div>
    <div v-show="show_calendar_view" class="scheduler-box">
      <div class="scheduler-indicator-box" v-if="processEventLoading && !calendarLoading">
        <div  class="scheduler-indicator">
          <dot-loader size='60px'></dot-loader>
        </div>
      </div>
      <div id='scheduler'></div>
    </div>

    <div v-show="!show_calendar_view">
      <div class='pagination'>
        <div><strong>{{$t('message.pagination.show')}}</strong> {{ paginator.from }} - {{ paginator.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ paginator.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
        <a class='btn' @click="paginator.prev_page_url && refreshAppointmentList(paginator.prev_page_url, paginator.current_page - 1)" :class="{ enable: paginator.prev_page_url }">{{$t('message.pagination.prev')}}</a>
        <a class='btn' @click="paginator.next_page_url && refreshAppointmentList(paginator.next_page_url, paginator.current_page + 1)" :class="{ enable: paginator.next_page_url }">{{$t('message.pagination.next')}}</a>
      </div>
      <table class='table table-striped'>
        <thead>
          <tr>
            <th>{{$t('message.appointment.order')}}</th>
            <th>{{$t('message.appointment.date')}}</th>
            <th>{{$t('message.appointment.patient')}}</th>
            <th>{{$t('message.appointment.doctor_name')}}</th>
            <th>{{$t('message.appointment.latest_reminded_time')}}</th>
            <th>{{$t('message.appointment.patient_status')}}</th>
            <th>{{$t('message.appointment.appointment_status')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="app in display_appointments" :key="app">
            <td>{{ app.id }}</td>
            <td>{{ displayAppointmentDate(app.start) }} <br/> {{ displayAppointmentTime(app.start, app.object.duration) }}</td>
            <td>{{ app.object.firstname }} {{ app.object.lastname }}</td>
            <td>{{ app.title }}</td>
            <td>{{ displayAppointmentDateTime(app.object.latest_reminded_time) }}</td>
            <td class="text-center">
            <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="app.object.patient_status!='inactive'"></i>
            <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="app.object.patient_status_3hr!='inactive'"></i>
            <i class="fa fa-minus text-danger" aria-hidden="true" v-if="app.object.patient_status=='inactive'"></i>
            <i class="fa fa-minus text-danger" aria-hidden="true" v-if="app.object.patient_status_3hr=='inactive'"></i>
            </td>
            <td>
            <dropdown :text="app.object.status" :type="getDropdownType(app.object.status)" :disabled="app.object.status == 'cancel'">
              <li class="status-change" v-if="app.object.status !== 'scheduled'"><a class="text-success" @click="changeStatus(app.id,'scheduled')">{{$t('message.appointment.status_scheduled')}}</a></li>
              <li class="status-change" v-if="app.object.status === 'scheduled' && app.object.patient_status === 'inactive'"><a class="text-success" @click="changeStatus(app.id,'patient_confirm')">{{$t('message.appointment.status_patient_confirm')}}</a></li>
              <li class="status-change" v-if="app.object.status === 'scheduled' && app.object.patient_status_3hr === 'inactive'"><a class="text-success" @click="changeStatus(app.id,'patient_confirm_3hr')">{{$t('message.appointment.status_patient_confirm_3hr')}}</a></li>
              <li class="status-change" v-if="app.object.status !== 'pending' && app.object.status !== 'checkin'"><a class="text-success" @click="changeStatus(app.id,'checkin')">{{$t('message.appointment.status_checkin')}}</a></li>
              <li class="status-change"><a class="text-danger" @click="cancelAppointment(app.id)">{{$t('message.appointment.status_cancel')}}</a></li>
            </dropdown>
          </td>
            <td><i class="btn btn-sm fa fa-edit" @click="editAppointment(app)"><small> {{$t('action_message.edit')}}</small></i></td>
          </tr>
          <tr v-if="display_appointments.length === 0 && appointmentLoaded && !appointmentLoading">
            <td colspan='8' style='text-align: center;' class='alert alert-warning'><span>{{$t('message.appointment.no_appointment_with_filter')}}</span></td>
          </tr>
          <tr v-if="appointmentLoading">
            <td colspan='8' style='text-align: center;' class='alert alert-warning'><div v-show='appointmentLoading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal -->
    <sweet-modal ref='exportCriteriaModel'>
      <div class="row">
        <div class='col-12'>
          <h2>เลือกวันที่</h2>
        </div>
        <div class='col-6 offset-3'>
          <flat-pickr v-model='export_date_range' :placeholder="$t('message.appointment.filter_date_range_placeholder')" :config="{ mode: 'range' }" id='export_date_range' class="flatpickr-input"></flat-pickr>
        </div>
        <div class='col-12 custom-field-wrap'>
          <a class="custom-field" v-on:click="openedExportFields=!openedExportFields">Custom fields</a>
        </div>
        <div class='col-12' v-if="openedExportFields">
          <form>
            <div class="form-check form-check-inline" v-for="field in exportFields" :key="field.id">
              <input class="form-check-input" type="checkbox" id="inlineCheckboxs1" :value="field.id" v-model="selectedExportFieldIds">
              <label class="form-check-label" for="inlineCheckbox1">{{field.name}}</label>
            </div>
            <div class="form-group" style="margin-top: 15px;">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="inlineCheckboxs1" :value="true" v-model="hasCustomSlot">
                <label class="form-check-label" for="inlineCheckbox1">Fixed Slot เวลา (นาที)</label>
              </div>
              <input type="text" style="width: 100px; display: inline-block;" class="form-control" id="หสนะ" placeholder="เลือก" v-model="slot" :disabled="!hasCustomSlot">
            </div>
          </form>
        </div>
        <div class='col-12'>
          <br/>
          <button class="btn btn-add btn-lg btn-success" @click="exportCurrentApponitments">{{$t('action_message.ok')}}</button>
        </div>
      </div>
    </sweet-modal>
    <sweet-modal ref='remarkModal' overlay-theme="dark">
      <remark-editor :valueRemarks.sync="templates.remark_templates" @closeEditor="closeRemarkModal" @submitRemark="updateRemarks" @comment-updated="updateComment($event)"></remark-editor>
    </sweet-modal>
    <sweet-modal ref='modal' overlay-theme="dark">
      <div class='form-wrapper'>
        <form @submit.prevent>
        <div class="row">
          <div class='col-md-6'>
            <h4 v-if="editMode">{{$t('message.appointment.title_edit')}}</h4>
            <h4 v-else>{{$t('message.appointment.title_add')}}</h4>
          </div>
          <div class='col-md-6 confirm-btn-group'>
            <dropdown class="confirm-btn-lg" v-if="appointment.status" :text="appointment.status" :type="getDropdownType(appointment.status)" :disabled="appointment.status == 'cancel'">
              <li class="status-change status-change-btn" v-if="appointment.status !== 'checkin'"><a class="text-success" @click="appointment.status = 'scheduled'">{{$t('message.appointment.status_scheduled')}}</a></li>
              <li class="status-change status-change-btn" v-if="appointment.status !== 'pending' && appointment.status !== 'checkin'"><a class="text-success" @click="appointment.status = 'checkin'">{{$t('message.appointment.status_checkin')}}</a></li>
              <li class="status-change status-change-btn"><a class="text-danger" @click="appointment.status = 'cancel '">{{$t('message.appointment.status_cancel')}}</a></li>
            </dropdown>
          </div>
        </div>
        <br/>
        <div class='row'>
          <div class='col-md-6'>
            <br/>
            <!-- <label for="fp">{{$t('message.appointment.label_date_time_appointment')}}</label> -->
            <flat-pickr v-model='appointment.appointment_time'
                        id="fp"
                        :config="fpConfig" required>
            </flat-pickr><br/>
          </div>
          <div class='col-md-6'>
            <br/>
            <!-- <label>{{$t('message.appointment.doctor')}}</label> -->
            <multiselect id="doctor" 
                    class="multi-select-form"
                    v-model="appointment.doctor" 
                    :placeholder="$t('message.appointment.doctor_placeholder')" 
                    :options="doctor_options"
                    :loading="doctorLoading"
                    @search-change="getDoctorsOptions"
                    :allow-empty="true" 
                    :disabled="appointment.status === 'cancel'"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
            <error-box :message="apmFrm.doctorIdError"/>
            <br/>
          </div>
        </div>

        <fieldset>
        <div class='col-md-12'>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input ref="patient_type_b" v-model='patient_type' type="radio" name='patient_type' value="exists" :disabled="appointment.status === 'cancel'"> {{$t('message.appointment.old_patient')}}
          </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input ref="patient_type_a" v-model='patient_type' type="radio" name='patient_type' value="noexists" :disabled="appointment.status === 'cancel'"> {{$t('message.appointment.new_patient')}}
          </label>
          </div>
        </div>

        <div v-if='patient_type == "exists"'>
          <multiselect id="patient" 
                    class="multi-select-form"
                    v-model="selected_patient" 
                    :placeholder="$t('message.appointment.search_patient_placeholder')" 
                    :options="patient_list"
                    :allow-empty="true" 
                    :disabled="appointment.status === 'cancel'"
                    :loading="patientLoading"
                    :internal-search="false"
                    @search-change="getPatients"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
        </div>

        <div class='row'>
          <div class="col-md-6">
            <br/>
            <multiselect id="prefix" 
                    class="multi-select-form"
                    v-model="appointment.prefix" 
                    :placeholder="this.$t('message.appointment.prefix_placeholder')" 
                    :options="prefix_options" 
                    :allow-empty="true" 
                    :disabled="appointment.status === 'cancel'"
                    :readonly="existing_patient"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
          </div>
        </div> 
        <div class='row'>
          <div class="col-md-6">
            <bs-input :readonly="existing_patient" class="remove-margin-bottom" v-model="appointment.firstname" :placeholder="$t('message.appointment.firstname_placeholder')" required :disabled="appointment.status === 'cancel'"></bs-input>
            <error-box :message="apmFrm.firstnameError"/>
          </div>
          <div class="col-md-6">
            <bs-input :readonly="existing_patient" class="remove-margin-bottom" v-model="appointment.lastname" :placeholder="$t('message.appointment.lastname_placeholder')" required :disabled="appointment.status === 'cancel'"></bs-input>
            <error-box :message="apmFrm.lastnameError"/>
          </div>
        </div>
        <br/>
        <div class='row'>
          <div class='col-md-6 phone-box'>
            <!-- <label>{{$t('message.appointment.phone')}}</label> -->
            <input type='tel' id='phone' :readonly="existing_patient" class='form-control' :disabled="appointment.status === 'cancel'">
            <error-box :message="apmFrm.phoneError"/>
          </div>
          <div class="col-md-6">
            <bs-input class='remove-margin-bottom' type='email' :readonly="existing_patient" v-model="appointment.email" :placeholder="$t('message.appointment.email_placeholder')" :disabled="appointment.status === 'cancel'"></bs-input>
            <error-box :message="apmFrm.emailError"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <br/>
            <bs-input :readonly="existing_patient" v-model="appointment.hn" :placeholder="$t('message.appointment.hn')" :disabled="appointment.status === 'cancel'"></bs-input>
          </div>
          <div class="col-md-6">
            <br/>
            <!-- <label>{{$t('message.appointment.locale')}}</label> -->
            <multiselect id="locale" 
                    class="multi-select-form"
                    v-model="appointment.locale" 
                    :placeholder="$t('message.appointment.locale_placeholder')" 
                    :options="locale_options" 
                    :allow-empty="false" 
                    :disabled="appointment.status === 'cancel'"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
          </div>
        </div>
      
        </fieldset>

        <div class='row'>
          <div class='col-md-6'>
            <br/>
            <!-- <label>{{$t('message.appointment.service')}}</label> -->
            <multiselect id="service" 
                    class="multi-select-form"
                    v-model="appointment.service" 
                    :placeholder="$t('message.appointment.service_placeholder')" 
                    :options="service_options" 
                    :allow-empty="true" 
                    :disabled="appointment.status === 'cancel'"
                    @select="changeAppointmentService"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
          </div>
          <div class='col-md-6'>
            <br/>
            <!-- <label>{{$t('message.appointment.duration')}}</label> -->
            <bs-input type="Number" class="input-min" min=10 max=1440 :step="5" v-model.number="appointment.duration" :placeholder="$t('message.appointment.duration_placeholder')" :disabled="appointment.status === 'cancel'">
               <span slot="after" class="input-group-addon">
                 <strong>{{$t('message.appointment.duration_unit')}}</strong>
               </span>
            </bs-input>
          </div>
        </div>
        <div v-if="appointment.comment" class="row">
          <div class="col-md-12">
            <label>{{$t('message.appointment.addition')}}</label>
            <p>{{appointment.comment}}</p>
          </div>
        </div>
        <!-- <bs-input type="textarea" :label="$t('message.appointment.addition')" :value="appointment.comment" :placeholder="$t('message.appointment.addition_placeholder')" :disabled="true"></bs-input> -->

        <div class="row">
          <div class="col-md-12">
            <div>
              <button v-for="rt in templates.remark_templates" :key="rt.name" @click="appendRemark(rt.text)" type="button" class="btn btn-secondary btn-sm btn-remark-template" :disabled="appointment.status === 'cancel'">{{rt.name}}</button>
              <button @click.prevent="openRemarkEditor" type="button" class="btn btn-secondary btn-sm btn-success" style="padding-bottom: 0px;"><i class="fa fa-pencil-square-o"></i></button>
            </div>
            <bs-input type="textarea" v-model="appointment.remark" :placeholder="`${$t('message.appointment.remark_placeholder')}`" :disabled="appointment.status === 'cancel'"></bs-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <bs-input type="textarea" v-model="appointment.admin_note" :placeholder="`${$t('message.appointment.admin_remark')}`" :disabled="appointment.status === 'cancel'"></bs-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="appointment.sms_feedback_to_patient">
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name">ส่ง Sms ถาม Feedback หลังมารักษา</label>
            </div>
          </div>
        </div>

        <div class="row" v-if="appointment.status">
          <div class="col-md-6">
            <a href="javascript:void(0)" @click.prevent="viewAppointmentDetail(appointment.id)">{{$t('message.appointment.view_more')}}</a>
          </div>
        </div>
        <br/>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-lg btn-close" @click="closeAppointmentModal">{{$t('action_message.close')}}</button>
            <button v-if="appointment.status !== 'cancel'" class="btn btn-add btn-lg btn-success" @click.stop="saveAppointment">{{ editMode ? $t('action_message.edit'): $t('action_message.save') }}</button>
            <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
            <button v-if="editMode && appointment.status !== 'cancel'" class="btn btn-add btn-lg btn-danger remove-action" @click="cancelAppointment(appointment.id)">{{$t('message.appointment.cancel_appointment')}}</button>
          </div>
        </div>
        </form>
      </div>
    </sweet-modal>

    <sweet-modal ref='dateModal' overlay-theme="dark">
      <div class='date-form'>
        <label>Select a date</label>
        <div class="input-group">
          <flat-pickr
          v-model="date"
          :config="dateConfig"
          class="form-control" 
          placeholder="Select date"               
          name="date">
          </flat-pickr>
          
          <div class="input-group-btn">
            <button class="btn btn-default" type="button" title="Toggle" data-toggle>
              <i class="fa fa-calendar">
                <span aria-hidden="true" class="sr-only">Toggle</span>
              </i>
            </button>
          </div>
        </div>
        <br>
        <button @click.prevent="gotoDate" class="btn btn-primary btn-lg">Ok</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="smsConfirmModalForCalendar" icon="info" title="ยืนยันการเปลี่ยนแปลงนัดหมาย?" class="sms-confirm-modal" v-on:close="cancelUpdateAppointmentTime()">
      คุณแน่ใจว่าต้องการเปลี่ยนแปลงนัดหมาย?
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="updateReq.sms_confirmation">
        <label for="defaultCheck1">
          ส่ง SMS ยืนยันไปที่คนไข้
        </label>
      </div>

      <div slot="button" class="btn btn-primary" @click="updateAppointmentTime(updateReq, true)">ยืนยัน</div>
      <div slot="button" class="btn btn-secondary" @click="$refs.smsConfirmModalForCalendar.close()">ยกเลิก</div>
    </sweet-modal>

    <sweet-modal ref="smsConfirmModalForFormChange" icon="info" title="ยืนยันการเปลี่ยนแปลงนัดหมาย?" class="sms-confirm-modal">
      คุณแน่ใจว่าต้องการเปลี่ยนแปลงนัดหมาย?
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="updateReq.sms_confirmation">
        <label for="defaultCheck1">
          ส่ง SMS ยืนยันไปที่คนไข้
        </label>
      </div>

      <div slot="button" class="btn btn-primary" @click="confirmAppointmentFormChange(updateReq)">ยืนยัน</div>
      <div slot="button" class="btn btn-secondary" @click="$refs.smsConfirmModalForFormChange.close()">ยกเลิก</div>
    </sweet-modal>

  </div>
</template>

<script>

import 'fullcalendar/dist/fullcalendar.min.css'
import 'fullcalendar-scheduler/dist/scheduler.min.css'
import 'flatpickr/dist/flatpickr.css'
import 'intl-tel-input/build/css/intlTelInput.css'
import 'fullcalendar'
import 'fullcalendar-scheduler'
import 'intl-tel-input'
import AppointmentMixin from './appointment_mixin'
import moment from 'moment'
import jq from 'jquery'
import Multiselect from 'vue-multiselect'
import { SweetModal } from 'sweet-modal-vue'
import flatPickr from 'vue-flatpickr-component'
import { input as BsInput, buttonGroup, radio, dropdown, modal } from 'vue-strap'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import DotLoader from 'vue-spinner/src/DotLoader'
import errorBox from '@/components/ErrorMessageBox'
import RemarkEditor from '@/components/RemarkEditor'

export default {
  mixins: [AppointmentMixin],
  components: {
    SweetModal,
    BsInput,
    flatPickr,
    buttonGroup,
    radio,
    SyncLoader,
    DotLoader,
    dropdown,
    errorBox,
    Multiselect,
    RemarkEditor,
    modal
  },
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showModal: false,
      monthView: 'month',
      weekView: 'agendaWeek',
      dayView: 'agendaDay',
      loading: false,
      selected_patient: null, // store selected patient from the patient list
      patient_list: [], // an option list for select existing patient
      patient_type: 'exists', // switch flag for adding a new or and old patient
      radioValue: null,
      resourcesAdded: false,
      filter_date_type: 'all', // 'range' and 'all'
      filter_date_range: (moment().format('YYYY-MM-DD') + ' to ' + moment().format('YYYY-MM-DD')), // flatpcikr filter appointment date in table view
      export_date_range: (moment().format('YYYY-MM-DD') + ' to ' + moment().format('YYYY-MM-DD')),
      viewType: 'daily', // calendar or list
      appointment: { duration: 15 }, // hold form data
      editMode: false,
      calendarLoading: false,
      appointmentLoading: false,
      appointmentLoaded: false,
      appointments: [],
      resources: [], // fullcalendar resource object
      events: [], // fullcalendar event object
      specialties: [],
      status_options: ['noshow', 'checkin', 'checkout', 'engaged', 'cancel', 'scheduled', 'rescheduled'].map(v => { return { label: v, value: v } }),
      services: [],
      rawServices: [],
      defaultDate: new Date(), // for full calendar
      filter_by_specialty: null,
      filter_by_doctor: null,
      filter_by_clinic: null,
      filter_by_status: null,
      filter_by_service: null,
      filter_by_hn: null,
      filter_search: null,
      count_search: 0,
      filter_searchs: '',
      filter_by_specialties: [],
      filter_by_doctors: [],
      filter_by_clinics: [],
      filter_by_status_list: [],
      filter_by_services: [],
      filter_by_hns: [],
      display_resources: [],
      display_events: [],
      doctor_options: [],
      clinic_options: [],
      service_options: [],
      locale_options: [
        {value: 'en', label: 'English'},
        {value: 'th', label: 'ไทย'}
      ],
      initedCalendar: false,
      fpConfig: {
        enableTime: true,
        altInput: true,
        wrap: true,
        time_24hr: true
      },
      dateConfig: {
        enableTime: false,
        altInput: true,
        wrap: true
      },
      fc: null, // full calendar instance
      apmFrm: this.getAppointmentFormError(),
      patientLoading: false,
      paginator: {},
      processEventLoading: false,
      doctors: [],
      doctorLoading: false,
      clinicLoading: false,
      hn_options: [],
      hnLoading: false,
      readyRenderCalendar: {},
      hnQuery: null,
      prefix_options: [
        {value: 'mrs', label: this.$t('message.appointment.prefix_mrs')},
        {value: 'mr', label: this.$t('message.appointment.prefix_mr')},
        {value: 'ms', label: this.$t('message.appointment.prefix_ms')},
        {value: 'master', label: this.$t('message.appointment.prefix_master')},
        {value: 'miss', label: this.$t('message.appointment.prefix_miss')}
      ],
      templates: {
        remark_templates: []
      },
      date: null,
      exportFields: [],
      selectedExportFieldIds: [],
      openedExportFields: false,
      updateReq: {
        start: null,
        end: null,
        appointment_id: null,
        sms_confirmation: true,
        loading: false
      },
      hasCustomSlot: false,
      slot: 10
    }
  },
  computed: {
    existing_patient () {
      return this.patient_type === 'exists'
    },
    show_calendar_view () {
      return (this.viewType === 'monthly') || (this.viewType === 'weekly') || (this.viewType === 'daily')
    },
    inview_doctors () {
      return this.resources.map(r => {
        return { label: r.title, value: r.id }
      })
    },
    inview_status () {
      let temp = []
      return this.appointments.map(a => {
        if (!temp.includes(a.object.status)) {
          temp.push(a.object.status)
          return { label: a.object.status, value: a.object.status }
        } else {
          return null
        }
      }).filter(_a => !!_a)
    },
    display_appointments () {
      let _apps = this.appointments
      if (this.filter_by_specialty && this.filter_by_specialty.value) {
        _apps = _apps.filter(r => {
          let d = r.object.doctor
          return d && d.specialities[0] && (d.specialities[0].name === this.filter_by_specialty.label)
        })
      }
      if (this.filter_by_doctor && this.filter_by_doctor.value) {
        _apps = _apps.filter(r => r.object.doctor && r.object.doctor.id === this.filter_by_doctor.value)
      }
      if (this.filter_by_service && this.filter_by_service.value && this.show_calendar_view) {
        _apps = _apps.filter(r => r.object.service_id === this.filter_by_service.value)
      }
      if (this.hnQuery) {
        _apps = _apps.filter(a => a.object.hn && a.object.hn.search(this.hnQuery) > -1)
      }
      return _apps
    }
  },
  methods: {
    changeAppointmentService (selectedOption, id) {
      const changeService = this.services.find(s => s.value === selectedOption.value)
      this.appointment.duration = changeService.duration
    },
    getSearch (search, doctor, specialty, status, type, from, to) {
      var params = {}
      if (doctor) {
        doctor = doctor.value
      }
      if (specialty) {
        specialty = specialty.value
      }
      if (type === 'all') {
        params = {
          clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
          doctor_id: doctor,
          search_term: search,
          specialty: specialty,
          start: 'all'
        }
      } else {
        if (!from && !to) {
          let dateSplitRange = 2
          let dates = this.filter_date_range.split('to')
          if (dates.length === dateSplitRange) {
            from = dates[0].trim()
            to = dates[1].trim()
          }
        }
        if (from && to) {
          params = {
            clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
            doctor_id: doctor,
            search_term: search,
            specialty: specialty,
            start: from,
            end: to
          }
        }
      }
      if (status && status.value) {
        params.status = status.value
      }
      this.appointmentLoaded = false
      this.appointmentLoading = true
      this.$http.get(this.$APP_CONFIG.api.appointments(),
        {
          params: params,
          credentials: true
        })
        .then(res => {
          this.appointmentLoading = false
          this.appointmentLoaded = true
          this.appointments = res.body.data
          this.paginator = Object.assign({}, {
            from: res.body.from,
            to: res.body.to,
            total: res.body.total,
            per_page: res.body.per_page,
            current_page: res.body.current_page,
            next_page_url: res.body.next_page_url,
            prev_page_url: res.body.prev_page_url
          })
        })
      // Gos
    },
    getDoctorsOptions (search) {
      var self = this
      var params = {
        doctor_name: search, clinic_id: self.$guser.user.clinic.id
      }
      if (self.filter_by_specialty && self.filter_by_specialty.value) {
        params.speciality_id = self.filter_by_specialty.value
      }
      self.doctorLoading = true
      this.$http.get(self.$APP_CONFIG.api.admin.doctors(), {
        params: params,
        credentials: true
      }).then(resp => {
        let doctors = resp.body.data.map(d => {
          if (!self.resources.find(r => r.id === d.id)) {
            self.resources.push({
              id: d.id, // doctor id
              title: `${(self.$i18n.locale === 'th') ? d.name_th : d.name_en}`,
              specialty: (d.specialities[0] && ((self.$i18n.locale === 'th') ? d.specialities[0].name_th : d.specialities[0].name_en)) || 'Other',
              order: 999
            })
          }

          return {
            value: d.id,
            label: (self.$i18n.locale === 'th') ? d.name_th : d.name_en,
            data: d
          }
        })
        doctors.forEach(d => {
          let fd = self.doctor_options.find(doctorOption => doctorOption.value === d.value)
          if (!fd) {
            self.doctor_options.push(d)
          }
        })
        self.doctorLoading = false
      })
    },
    getClinicsOptions (search) {
      // list clinics
    },
    getPatients (search) {
      this.patientLoading = true
      this.$http.get(this.$APP_CONFIG.api.admin.patient(),
        { params: { clinic_id: this.$guser.user.clinic.id, search } }).then(res => {
          this.patientLoading = false
          this.patient_list = res.body.data.map(p => {
            return { label: this.patientDesc(p), value: p.id, data: p }
          })
        })
    },
    patientDesc (p) {
      return `${p.firstname} ${p.lastname} - ${p.phone} ${p.email ? '- ' + p.email : ''} ${p.hn ? '- HN:' + p.hn : ''}`
    },
    getHnOptions (search) {
      var self = this
      var params = {
        doctor_name: search, clinic_id: self.$guser.user.clinic.id
      }
      if (self.filter_by_specialty && self.filter_by_specialty.value) {
        params.speciality_id = self.filter_by_specialty.value
      }
      self.doctorLoading = true
      this.$http.get(self.$APP_CONFIG.api.admin.doctors(), {
        params: params,
        credentials: true
      }).then(resp => {
        let doctors = resp.body.data.map(d => {
          if (!self.resources.find(r => r.id === d.id)) {
            self.resources.push({
              id: d.id, // doctor id
              title: `${(self.$i18n.locale === 'th') ? d.name_th : d.name_en}`,
              specialty: (d.specialities[0] && ((self.$i18n.locale === 'th') ? d.specialities[0].name_th : d.specialities[0].name_en)) || 'Other',
              order: 999
            })
          }
          return {
            value: d.id,
            label: (self.$i18n.locale === 'th') ? d.name_th : d.name_en,
            data: d
          }
        })
        doctors.forEach(d => {
          let fd = self.doctor_options.find(doctorOption => doctorOption.value === d.value)
          if (!fd) {
            self.doctor_options.push(d)
          }
        })

        self.doctorLoading = false
      })
    },
    openNewAppointmentForm (isStatus) {
      this.editMode = false
      this.$refs.patient_type_a.click()
      this.appointment = Object.assign({
        id: null,
        firstname: null,
        lastname: null,
        phone: '',
        duration: 15,
        service_id: null,
        doctor_id: null,
        comment: null,
        email: null,
        remark: null,
        locale: this.locale_options.find(s => s.value === this.$i18n.locale),
        admin_note: null,
        sms_feedback_to_patient: true
      }, { appointment_time: moment().format('YYYY-MM-DD 09:00') })
      if (isStatus) {
        this.$refs.modal.open() // open appointment form dialog
      }
      jq('#phone').intlTelInput('setNumber', '')
      this.templates.remark_templates = this.$guser.user.clinic.remark_templates
    },
    async delay (time) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, time)
      })
    },
    async switchView (v) {
      this.viewType = v
      await this.delay(1)
      this.appointments = []

      if (v === 'monthly' || v === 'weekly' || v === 'daily') {
        if (this.initedCalendar) {
          // this.fc.fullCalendar('removeEvents')
          if (v === 'monthly') {
            this.fc.fullCalendar('changeView', this.monthView)
            // this.readyRenderCalendar[this.monthView] = true
          } else if (v === 'weekly') {
            this.fc.fullCalendar('changeView', this.weekView, moment().format('YYYY-MM-DD'))
            // this.readyRenderCalendar[this.weekView] = true
          } else if (v === 'daily') {
            this.fc.fullCalendar('changeView', this.dayView, moment().format('YYYY-MM-DD'))
          }
        } else {
          await this.setupCalendar()
        }
        return
      }

      if (v === 'list') {
        this.viewType = 'list'
        this.hnQuery = null
        this.filter_date_type = 'range'
        if (!this.filter_date_range) {
          // set to today
          this.filter_date_range = (moment().format('YYYY-MM-DD') + ' to ' + moment().format('YYYY-MM-DD'))
        } else {
          // reload
          this.loadAppointments(this.filter_by_status, this.filter_date_type)
        }
      }
    },
    async switchTime (type) {
      if (type === 'range') {
        this.filter_date_type = 'range'
      } else {
        this.filter_date_type = 'all'
      }
      await this.loadAppointments(this.filter_by_status, this.filter_date_type)
    },
    _buildAppointment (ap) {
      if (ap.object.ehr_patient_id) {
        this.$refs.patient_type_b.click()
        this.selected_patient = { label: this.patientDesc(ap.object), value: ap.object.ehr_patient_id, data: ap.object }
        this.patient_list = [
          this.selected_patient
        ]
      } else {
        this.$refs.patient_type_a.click()
      }
      return {
        id: ap.object.id,
        firstname: ap.object.firstname,
        lastname: ap.object.lastname,
        appointment_time: ap.object.appointment_time,
        duration: ap.object.duration,
        service_id: ap.object.service_id,
        service: this.services.find(s => s.value === ap.object.service_id),
        doctor_id: ap.object.doctor_id,
        doctor: this.doctor_options.find(d => d.value === ap.object.doctor_id),
        comment: ap.object.comment,
        remark: ap.object.remark,
        locale: this.locale_options.find(s => s.value === ap.object.locale),
        admin_note: ap.object.admin_note,
        email: ap.object.email,
        status: ap.object.status,
        ehr_patient_id: ap.object.ehr_patient_id,
        phone: ap.object.phone,
        birthday: ap.object.birthday,
        prefix: ap.object.prefix,
        id_card: ap.object.id_card,
        hn: ap.object.hn,
        sms_feedback_to_patient: ap.object.sms_feedback_to_patient
      }
    },
    async removeAppointment () {
      if (await this.$confirm(this.$t('message.appointment.are_you_wath_to_cancel'))) {
        this.$http.delete(this.$APP_CONFIG.api.appointment_id(this.appointment.id)).then(res => {
          if (res.body) {
            this.$refs.modal.close()
            this.editMode = false
            this.$toastr.success(this.$t('message.appointment.cancel_appointment_success'))
            if (this.show_calendar_view) {
              this.fc.fullCalendar('removeEvents', res.body.id)
            } else {
              this.appointments = this.appointments.filter(a => a.id !== res.body.id)
            }
          }
        })
      }
    },
    async cancelAppointment (id) {
      if (await this.$confirm(this.$t('message.appointment.are_you_wath_to_cancel'))) {
        this.$http.put(this.$APP_CONFIG.api.admin.appointment_action(id, 'cancel')).then(res => {
          if (res.body) {
            this.$refs.modal.close()
            this.editMode = false
            this.$toastr.success(this.$t('message.appointment.cancel_appointment_success'))
            if (this.show_calendar_view) {
              this.refetchEventsDelay()
            } else {
              this.loadAppointments(this.filter_by_status, this.filter_date_type)
            }
          }
        })
      }
    },
    editAppointment (ap) {
      this.editMode = true
      this.appointment = this._buildAppointment(ap)
      this.$refs.modal.open()
      jq('#phone').intlTelInput('setNumber', ap.object.phone)
    },
    displayAppointmentDate (start) {
      return moment(start).format('LL')
    },
    displayAppointmentDateTime (date) {
      if (!date) return ''
      return moment(date).format('LLL')
    },
    displayAppointmentTime (start, duration) {
      let minuteUnit = 60
      let millisUnit = 1000
      let s = moment(start)
      duration = (+duration || 0) // in minute
      let end = moment(s.valueOf() + duration * minuteUnit * millisUnit)
      let ms = moment(s)
      let me = moment(end)
      return `${ms.format('LT')} - ${me.format('LT')}`
    },
    closeAppointmentModal () {
      this.appointment = {}
      this.clearAppointmentFormError()
      this.$refs.modal.close()
    },
    async changeStatus (id, status) {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        let params = {}
        if (status === 'patient_confirm') {
          params.status = 'scheduled'
          params.patient_status = 'confirmed'
        } else if (status === 'patient_confirm_3hr') {
          params.status = 'scheduled'
          params.patient_status_3hr = 'confirmed'
        } else {
          params.status = status
        }
        this.$http.put(this.$APP_CONFIG.api.admin.appointment_id(id), params).then(res => {
          if (res.body.id) {
            this.loading = false
            this.$toastr.success(this.$t('action_message.save_success'))
            this.$refs.modal.close()
            this.appointment = {} // clear store
            if (this.show_calendar_view) this.refetchEventsDelay()
            this.loadAppointments(this.filter_by_status, this.filter_date_type)
          }
        })
      }
    },
    getDropdownType (appointmentStatus) {
      if (appointmentStatus === 'scheduled') {
        return 'success'
      } else if (appointmentStatus === 'checkin') {
        return 'success'
      } else if (appointmentStatus === 'pending') {
        return 'warning'
      } else if (appointmentStatus === 'cancel') {
        return ''
      }

      return ''
    },
    extractAppointment () {
      let _a = Object.assign({
        clinic_id: this.$guser.user.clinic.id,
        seen_doctor: 0,
        has_medical_record: 0
      }, this.appointment, {
        phone: jq('#phone').intlTelInput('getNumber'),
        sms_remark: this.appointment.remark
      })

      // convert time
      if (this.appointment.appointment_time) {
        let mtime = moment(this.appointment.appointment_time).format('YYYYMMDDHHmm')
        _a.appointment_time = mtime
      }

      // extract service id
      if (this.appointment.service) {
        _a.service_id = this.appointment.service.value
        delete _a.service
      }

      // extract doctor id
      if (this.appointment.doctor) {
        _a.doctor_id = this.appointment.doctor.value
        delete _a.doctor
      }

      // extract locale
      if (this.appointment.locale) {
        _a.locale = this.appointment.locale.value
      }

      // extract prefix
      if (this.appointment.prefix) {
        _a.prefix = this.appointment.prefix.value
      }

      return _a
    },
    cancelUpdateAppointmentTime () {
      if (!this.updateReq.loading) {
        this.updateReq.revertFunc()
      }
    },
    async updateAppointmentTime (obj) {
      // let start = moment(event.start).format('YYYYMMDDHHmm')
      // let end = moment(event.end || event.start).format('YYYYMMDDHHmm')
      this.updateReq.loading = true

      this.$refs.smsConfirmModalForCalendar.close()
      let res = await this.$http.put(this.$APP_CONFIG.api.admin.appointment_id(obj.appointment_id), {
        start: obj.start,
        end: obj.end,
        sms_confirmation_to_patient: obj.sms_confirmation
      })

      if (res.body.id) {
        let ev = this.events.find(ev => ev.id === obj.appointment_id)
        ev.start = obj.start
        ev.end = obj.end

        let ap = this.appointments.find(a => a.id === obj.appointment_id)
        ap.object.appointment_time = moment(obj.start).format('YYYY-MM-DD HH:mm:ss')
        this.$toastr.success(this.$t('action_message.save_success'))
      } else {
        this.$toastr.warning(this.$t('action_message.save_not_success'))
      }
      this.updateReq.loading = false
      return res
    },
    confirmAppointmentFormChange (req) {
      this.appointment.sms_confirmation_to_patient = req.sms_confirmation
      this.addOrUpdateAppointment()
      // close everything
      this.$refs.smsConfirmModalForFormChange.close()
      this.$refs.modal.close()
    },
    saveAppointment () {
      // Update appointment open modal
      if (this.appointment.id) {
        // open modal
        this.$refs.smsConfirmModalForFormChange.open()
      } else {
        this.addOrUpdateAppointment()
      }
    },
    addOrUpdateAppointment () {
      if (this.appointment.status === 'cancel ') {
        this.cancelAppointment(this.appointment.id)
        return
      }

      let _a = this.extractAppointment()

      this.clearAppointmentFormError()
      // Validate form
      let defaultError = this.getAppointmentFormDefaultError()
      var invalid = false
      if (!_a.firstname) {
        this.apmFrm.firstnameError = defaultError.firstnameError
        invalid = true
      }

      if (!_a.lastname) {
        this.apmFrm.lastnameError = defaultError.lastnameError
        invalid = true
      }

      /* if (!_a.phone) {
        this.apmFrm.phoneError = defaultError.phoneError
        invalid = true
      } */

      if (!_a.doctor_id) {
        this.apmFrm.doctorIdError = defaultError.doctorIdError
        invalid = true
      }

      if (invalid) {
        return
      }

      if (this.appointment.id) {
        // update
        this.loading = true
        this.$http.put(this.$APP_CONFIG.api.admin.appointment_id(_a.id), _a).then(res => {
          if (res.body.id) {
            this.loading = false
            this.$toastr.success(this.$t('action_message.save_success'))
            this.$refs.modal.close()
            this.appointment = {} // clear store
            if (this.fc && this.show_calendar_view) this.refetchEventsDelay()
            this.loadAppointments(this.filter_by_status, this.filter_date_type)
          }
        },
        error => {
          this.loading = false
          this.showAppointmentFormFromError(error.body.error)
        })
      } else {
        this.loading = true
        this.$http.post(this.$APP_CONFIG.api.admin.appointment(), _a).then(res => {
          this.loading = false
          if (res.body.id) {
            this.$toastr.success(this.$t('action_message.save_success'))
            this.$refs.modal.close()
            this.appointment = {} // clear store
            this.selected_patient = null
            this.patient_list = []
            if (this.fc && this.show_calendar_view) {
              this.refetchEventsDelay()
            } else {
              this.loadAppointments(this.filter_by_status, this.filter_date_type)
            }
          }
        },
        error => {
          this.loading = false
          this.showAppointmentFormFromError(error.body.error)
        })
      }
    },
    filterEvent () {
      if (!this.show_calendar_view) {
        this.loadAppointments(this.filter_by_status, this.filter_date_type)
        return this.events
      }
      let _resources = this.resources.slice()
      let _events = this.events.slice()

      if (this.filter_by_specialty && this.filter_by_specialty.value) {
        _resources = _resources.filter(r => r.specialty === this.filter_by_specialty.label || r.status === 'background')
      }
      if (this.filter_by_doctor && this.filter_by_doctor.value) {
        _resources = _resources.filter(r => r.id === this.filter_by_doctor.value || r.status === 'background')
      }
      if (this.filter_by_status && this.filter_by_status.value) {
        _events = _events.filter(r => r.status === this.filter_by_status.value || r.status === 'background')
      }
      if (this.filter_by_service && this.filter_by_service.value && this.show_calendar_view) {
        _events = _events.filter(r => r.service_id === this.filter_by_service.value || r.status === 'background')
      }
      if (this.filter_by_hn && this.filter_by_hn.value && !this.show_calendar_view) {
        _events = _events.filter(r => r.service_id === this.filter_by_hn.value || r.status === 'background')
      }

      // refresh new schedule data
      if (this.fc) {
        this.resources.forEach(r => {
          this.fc.fullCalendar('removeResource', r.id)
        })

        this.fc.fullCalendar('removeEvents')

        let scResouces = []
        let scOthResouces = []
        let scOthResouces2 = []
        let resourceSize = 10
        var count = 0
        _resources.forEach(rs => {
          let ev = _events.find(_e => rs.id === _e.resourceId && (_e.type === 'appointment' || rs.is_today === 1))
          if (ev && count < resourceSize) {
            rs.order = count
            scResouces.push(rs)
            count++
          } else {
            scOthResouces.push(rs)
          }
        })

        scOthResouces.forEach(rs => {
          let ev = _events.find(_e => rs.id === _e.resourceId && _e.status === 'background')
          if (ev && count < resourceSize) {
            rs.order = count
            scResouces.push(rs)
            count++
          } else {
            scOthResouces2.push(rs)
          }
        })

        scResouces.forEach(_r => {
          this.fc.fullCalendar('addResource', _r)
        })

        scOthResouces2.forEach(_r => {
          if (count < resourceSize) {
            _r.order = count
            this.fc.fullCalendar('addResource', _r)
            count++
          }
        })

        // this.fc.fullCalendar('addEventSource', _events)
      }
      return _events
    },
    refreshAppointmentList (url, pageNum) {
      if (url) {
        this.appointmentLoaded = false
        this.appointmentLoading = true
        let params = {
          clinic_id: this.$guser.user.clinic.id,
          doctor_id: this.filter_by_doctor ? this.filter_by_doctor.value : null,
          status: this.filter_by_status ? this.filter_by_status.value : null,
          page: pageNum,
          start: 'all'
        }

        let from = null
        let to = null
        let dateSplitRange = 2
        let dates = this.filter_date_range.split('to')

        if (this.filter_date_type === 'all') {
          params.start = 'all'
        } else {
          if (dates.length === dateSplitRange) {
            from = dates[0].trim()
            to = dates[1].trim()
          }
          if (from && to) {
            params.start = from
            params.end = to
          }
        }

        this.$http.get(this.$APP_CONFIG.api.appointments(),
          {
            params: params,
            credentials: true
          })
          .then(res => {
            this.appointmentLoading = false
            this.appointmentLoaded = true
            this.appointments = res.body.data
            this.paginator = Object.assign({}, {
              from: res.body.from,
              to: res.body.to,
              total: res.body.total,
              per_page: res.body.per_page,
              current_page: res.body.current_page,
              next_page_url: res.body.next_page_url,
              prev_page_url: res.body.prev_page_url
            })
          })
      }
    },
    async loadAppointments (status, type, from, to) {
      let params = {}
      params.doctor_id = this.$guser.user.doctor ? this.$guser.user.doctor.id : null
      params.clinic_id = this.$guser.user.clinic ? this.$guser.user.clinic.id : null

      if (this.filter_by_doctor) {
        params.doctor_id = this.filter_by_doctor.value
      }
      if (this.filter_by_clinic) {
        params.clinic_id = this.filter_by_clinic.value
      }

      if (type === 'all') {
        /* params = {
          clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
          doctor_id: this.filter_by_doctor ? this.filter_by_doctor.id : null,
          start: 'all'
        } */
        params.start = 'all'
      } else {
        if (!from && !to) {
          let dateSplitRange = 2
          let dates = this.filter_date_range.split('to')
          if (dates.length === dateSplitRange) {
            from = dates[0].trim()
            to = dates[1].trim()
          }
        }

        if (from && to) {
          /* params = {
            clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
            doctor_id: this.$guser.user.doctor ? this.$guser.user.doctor.id : null,
            start: from,
            end: to
          } */
          params.start = from
          params.end = to
        }
      }

      if (status && status.value) {
        params.status = status.value
      }

      this.appointmentLoaded = false
      this.appointmentLoading = true

      let res = await this.$http.get(this.$APP_CONFIG.api.appointments(), {
        params: params,
        credentials: true
      })
      this.appointmentLoading = false
      this.appointmentLoaded = true
      this.appointments = res.body.data
      this.paginator = Object.assign({}, {
        from: res.body.from,
        to: res.body.to,
        total: res.body.total,
        per_page: res.body.per_page,
        current_page: res.body.current_page,
        next_page_url: res.body.next_page_url,
        prev_page_url: res.body.prev_page_url
      })
    },
    openExportCriteria () {
      this.$refs.exportCriteriaModel.open()
    },
    async loadExportFields () {
      let res = await this.$http.get(this.$APP_CONFIG.api.appointmentsExportFields(), { credentials: true })
      this.exportFields = res.body

      // Select Export fields
      this.exportFields.forEach((f, index) => {
        if (f.default) {
          this.selectedExportFieldIds.push(f.id)
        }
      })
    },
    exportCurrentApponitments () {
      let dateSplitRange = 2
      let dates = this.export_date_range.split(' to ')
      if (dates.length === dateSplitRange) {
        let from = dates[0].trim()
        let to = dates[1].trim()
        this.exportApponitments(this.filter_by_status, from, to)
      } else {
        this.exportApponitments(this.filter_by_status)
      }
      this.$refs.exportCriteriaModel.close()
    },
    exportApponitments (status, from, to) {
      var params = {}
      if (!from && !to) {
        let dateSplitRange = 2
        let dates = this.export_date_range.split(' to ')
        if (dates.length === dateSplitRange) {
          from = dates[0].trim()
          to = dates[1].trim()
        }
      }

      if (from && to) {
        params = {
          clinic_id: this.$guser.user.clinic.id,
          start: from,
          end: to
        }
      }

      if (status && status.value) {
        params.status = status.value
      }

      if (this.filter_by_doctor) {
        params.doctor_id = this.filter_by_doctor.value
      }

      var exportUrl = this.$APP_CONFIG.api.appointmentsExport() + '?'
      for (const key of Object.keys(params)) {
        exportUrl += '&' + key + '=' + params[key]
      }

      if (this.openedExportFields) {
        for (const id of this.selectedExportFieldIds) {
          exportUrl += '&fields[]=' + id
        }
      }

      if (this.hasCustomSlot) {
        exportUrl += '&slot=' + this.slot
      }

      window.open(exportUrl, '_blank')
    },
    setupFilter () {
      if (this.$route.query.status === 'pending' ||
      this.$route.query.status === 'scheduled' ||
      this.$route.query.status === 'cancel') {
        // reset others filters
        this.filter_by_specialties = []
        this.filter_by_doctors = []
        this.filter_by_services = []

        // set pending status
        this.filter_by_status = {
          value: this.$route.query.status,
          label: this.$route.query.status
        }

        this.filter_by_status_list = [
          this.filter_by_status
        ]

        // set view type
        this.viewType = 'list'
        this.filter_date_type = 'all'
      } else {
        this.filter_by_status_list = []
      }

      switch (this.$route.query.viewType) {
        case 'daily':
          this.viewType = 'daily'
          break
        case 'monthly':
          this.viewType = 'monthly'
          break
        case 'list':
          this.viewType = 'list'
          break
        default:
          this.viewType = 'list'
      }
    },
    clearAppointmentFormError () {
      this.apmFrm = this.getAppointmentFormError()
    },
    getAppointmentFormError () {
      return {
        firstnameError: null,
        lastnameError: null,
        phoneError: null,
        emailError: null,
        doctorIdError: null
      }
    },
    getAppointmentFormDefaultError () {
      return {
        firstnameError: this.$t('message.appointment.firstname_require'),
        lastnameError: this.$t('message.appointment.lastname_require'),
        phoneError: this.$t('message.appointment.phone_require'),
        emailError: this.$t('message.appointment.email_require'),
        doctorIdError: this.$t('message.appointment.doctor_require')
      }
    },
    showAppointmentFormFromError (error) {
      if (error) {
        this.apmFrm.firstnameError = this.getMessageFromError(error.firstname)
        this.apmFrm.lastnameError = this.getMessageFromError(error.lastname)
        this.apmFrm.phoneError = this.getMessageFromError(error.phone)
        this.apmFrm.doctorIdError = this.getMessageFromError(error.doctor_id)
      }
    },
    getMessageFromError (errorObj) {
      var message = null
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ')
      } else {
        message = errorObj
      }
      return message
    },
    viewAppointmentDetail (id) {
      this.$refs.modal.close()
      setTimeout(() => this.$router.push({ path: '/appointments/' + id }), 300)
    },
    async setupCalendar () {
      this.calendarLoading = true
      await this.renderCalendar()
      this.filter_date_type = 'all'
      this.calendarLoading = false
      this.initedCalendar = true
    },
    async loadInitData () {
      // Get status list
      let appmStat = await this.$http.get(this.$APP_CONFIG.api.admin.appointment_status(), { credentials: true })
      if (appmStat) {
        this.status_options = appmStat.body.map(v => { return { label: v, value: v } })
      }
      let spct = await this.$http.get(this.$APP_CONFIG.api.specialties())
      if (spct) {
        this.specialties = spct.body.map(r => {
          return { label: r.name, value: r.id }
        })
      }

      // Get clinic appointment info
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        let srvList = await this.$http.get(this.$APP_CONFIG.api.admin.clinicme(this.$route, this.$guser))
        if (srvList) {
          this.rawServices = Object.assign({}, srvList.body.data.services)
          this.services = srvList.body.data.services.map(s => {
            return { label: s[this.$i18n.locale].name, value: s.id, duration: s.duration }
          })
        }

        // get doctor list for this clinic to be calendar resources and drop list options used when create new appointment
        let dtList = await this.$http.get(this.$APP_CONFIG.api.admin.doctors(), { params: { clinic_id: this.$guser.user.clinic.id, disable_pagination: 0 } })
        if (dtList) {
          // add to calendar resource
          if (!this.doctor_options) {
            this.doctor_options = []
          }
          dtList.body.data.forEach((d, index) => {
            if (index) {
              this.doctor_options.push({
                label: (this.$i18n.locale === 'th') ? d.name_th : d.name_en,
                value: d.id,
                data: d
              })
            }

            if (!this.resources.find(r => r.id === d.id)) {
              this.resources.push({
                id: d.id, // doctor id
                title: `${(this.$i18n.locale === 'th') ? d.name_th : d.name_en}`,
                specialty: (d.specialities[0] && ((this.$i18n.locale === 'th') ? d.specialities[0].name_th : d.specialities[0].name_en)) || 'Other',
                order: 999
              })
            }
          })
        }
        let srvOpt = await this.$http.get(this.$APP_CONFIG.api.admin.clinicme_services(this.$route, this.$guser))
        if (srvOpt) {
          this.service_options = srvOpt.body.data.map(service => {
            return { label: service[this.$i18n.locale].name, value: service.id }
          })
        }

      // Get clinic appointment info
      } else if (this.$guser.isDoctor()) {
        let d = this.$guser.user.doctor
        this.resources.push({
          id: d.id, // doctor id
          title: d.prefix + ' ' + d.firstname + ' ' + d.lastname,
          specialty: d.specialities[0].name || 'Other',
          order: 999
        })
      }
    },
    async renderCalendar () {
      let self = this
      // let initTime = null
      return new Promise(resolve => {
        if (this.fc) {
          resolve('done')
        } else {
          this.fc = jq('#scheduler')
          // init fullcalendar with events
          // doc: https://fullcalendar.io/docs/views/Available_Views/
          this.fc.fullCalendar({
            locale: this.$i18n.locale,
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
            defaultView: this.dayView,
            defaultDate: self.defaultDate,
            resourceGroupField: 'specialty',
            resourceOrder: 'order',
            editable: true,
            slotLabelFormat: 'HH:mm',
            titleFormat: 'ddd MMM D, YYYY',
            allDaySlot: false,
            height: 600,
            slotDuration: '00:10:00',
            scrollTime: '08:00:00',
            eventLimit: false,
            lazyFetching: false,
            customButtons: {
              addAppointmentBtn: {
                text: this.$t('message.appointment.add_appointment'),
                click () {
                  // show dialog for adding new appointment
                  self.$refs.modal.open()
                }
              },
              selectDate: {
                text: '...',
                click () {
                  self.$refs.dateModal.open()
                }
              }
            },
            header: {
              left: 'prev, today',
              center: 'title, selectDate',
              right: 'next'
            },
            slotEventOverlap: false,
            resourceLabelText: this.$t('message.appointment.doctor_list'),
            resources: [],
            async events (start, end, timezone, callback) {
              let events = []
              if (this.startEndTemp === undefined || this.startEndTemp !== start.format() + end.format()) {
                events = await self.processEventCalendar(start, end, timezone, callback, null)
              }
              this.startEndTemp = start.format() + end.format()
              callback(events)
            },
            eventDrop (event, delta, revertFunc, jsEvent, ui, view) {
              self.updateReq.start = moment(event.start).format('YYYYMMDDHHmm')
              self.updateReq.end = moment(event.end || event.start).format('YYYYMMDDHHmm')
              self.updateReq.appointment_id = event.id
              self.updateReq.revertFunc = revertFunc
              self.$refs.smsConfirmModalForCalendar.open()
              /* self.$http.put(self.$APP_CONFIG.api.admin.appointment_id(event.id),
                { start, end }).then(res => {
                  if (res.body.id) {
                    let ev = self.events.find(ev => ev.id === event.id)
                    ev.start = event.start
                    ev.end = event.end

                    let ap = self.appointments.find(a => a.id === event.id)
                    ap.object.appointment_time = moment(event.start).format('YYYY-MM-DD HH:mm:ss')
                    self.$toastr.success(self.$t('action_message.save_success'))
                  } else {
                    self.$toastr.warning(self.$t('action_message.save_not_success'))
                  }
                }) */
            },
            eventResize (event, jsEvent, ui, view) {
              let start = moment(event.start).format('YYYYMMDDHHmm')
              let end = moment(event.end || event.start).format('YYYYMMDDHHmm')
              // let end = moment(event.start).add(delta).format('YYYYMMDDHHmm')
              self.$http.put(self.$APP_CONFIG.api.admin.appointment_id(event.id),
                { start, end }).then(res => {
                  if (res.body.id) {
                    // update current event
                    let ev = self.events.find(ev => ev.id === event.id)
                    ev.start = event.start
                    ev.end = event.end
                    self.$toastr.success(self.$t('action_message.save_success'))
                  } else {
                    self.$toastr.warning(self.$t('action_message.save_not_success'))
                  }
                })
            },
            eventClick (event, jsEvent, view) {
              var ap = self.appointments.find(a => a.id === event.id)
              if (ap) {
                self.editMode = true
                self.appointment = self._buildAppointment(ap)
                // Disable form if it is a doctor
                if (self.$guser.isDoctor()) {
                  self.appointment.status = 'cancel'
                }
                self.$refs.modal.open()
                jq('#phone').intlTelInput('setNumber', ap.object.phone)
              } else {
                this.$refs.patient_type_a.click()
                self.editMode = false
                let _doctor = self.doctor_options.find(d => d.value === +event.resourceId)
                self.appointment = Object.assign({
                  id: null,
                  firstname: null,
                  lastname: null,
                  phone: '',
                  duration: event.time_slots,
                  service_id: null,
                  doctor_id: null,
                  doctor: _doctor,
                  comment: null,
                  remark: null,
                  locale: this.locale_options.find(s => s.value === this.$i18n.locale),
                  admin_note: null,
                  email: null,
                  ehr_patient_id: null,
                  birthday: null,
                  prefix: null,
                  id_card: null,
                  hn: null,
                  sms_feedback_to_patient: true
                }, { appointment_time: moment(event.start, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm') })
                self.$refs.modal.open() // open appointment form dialog
                jq('#phone').intlTelInput('setNumber', '')
              }
            },
            dayClick (date, jsEvent, view, resource) {
              // Doctor is not able to create new appointment
              if (self.$guser.isDoctor()) {
                return
              }

              // default proper working hour
              let f = (date.format('HH') === '00') ? 'YYYY-MM-DD 09:mm' : 'YYYY-MM-DD HH:mm'

              // add default doctor when click in daily view
              let _doctor = null
              if (resource) {
                _doctor = self.doctor_options.find(d => d.value === +resource.id)
              }

              if (self.filter_by_doctors.length > 0) {
                _doctor = {
                  data: self.filter_by_doctors[0].data,
                  label: self.filter_by_doctors[0].data.name,
                  value: self.filter_by_doctors[0].data.id
                }
              }
              self.editMode = false
              self.appointment = Object.assign({
                id: null,
                firstname: null,
                lastname: null,
                phone: '',
                duration: 15,
                service_id: null,
                doctor_id: null,
                doctor: _doctor,
                comment: null,
                remark: null,
                locale: self.locale_options.find(s => s.value === self.$i18n.locale),
                admin_note: null,
                email: null,
                ehr_patient_id: null,
                birthday: null,
                prefix: null,
                id_card: null,
                hn: null,
                sms_feedback_to_patient: true
              }, { appointment_time: date.format(f) })
              self.$refs.modal.open() // open appointment form dialog
              jq('#phone').intlTelInput('setNumber', '')
            },
            eventRender (event, element) {
              jq(element).find('.fc-content').addClass('text_white')
              var ap = self.appointments.find(a => a.id === event.id)
              if (ap && ap.object && ap.object.admin_note) {
                jq(`<span> - ${ap.object.admin_note}</span>`).appendTo(jq(element).find('.fc-content'))
              }

              // if (event.patient_status && event.patient_status !== 'inactive') {
              //   jq(`<i class="fa fa-check-circle" aria-hidden="true"> ${self.$t('message.appointment.confirm_status')}</i>`).appendTo(jq(element).find('.fc-content'))
              // } else if (event.patient_status) {
              //   jq(`<i class="fa fa-minus" aria-hidden="true"> ${self.$t('message.appointment.not_confirm_status')}</i>`).appendTo(jq(element).find('.fc-content'))
              // }
            },
            viewRender () {
              resolve('done')
            }
          })
        }
      })
    },
    getAppointmentParams (start, end) {
      var appointmentParams = {
        clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
        doctor_id: this.$guser.user.doctor ? this.$guser.user.doctor.id : null,
        start: start.format('YYYY-MM-DD'),
        end: end.subtract(1, 'days').format('YYYY-MM-DD')
      }

      if (this.filter_by_doctor && this.filter_by_doctor.value) {
        appointmentParams.doctor_id = this.filter_by_doctor.value
      }
      if (this.filter_by_specialty && this.filter_by_specialty.value) {
        appointmentParams.speciality_id = this.filter_by_specialty.value
      }
      if (this.filter_by_status && this.filter_by_status.value) {
        appointmentParams.status = this.filter_by_status.value
      }
      if (this.filter_by_service && this.filter_by_service.value && this.show_calendar_view) {
        appointmentParams.service_id = this.filter_by_service.value
      }
      return appointmentParams
    },
    refetchEventsDelay () {
      if (this.fc) {
        this.fc.fullCalendar('refetchEvents')
      }
    },
    async processEventCalendar (start, end, timezone, callback, renderedCallback) {
      this.processEventLoading = true
      // update default date when adding new AP
      let startApDate = start.format('YYYY-MM-DD')
      let endApDate = end.format('YYYY-MM-DD')
      this.appointment.appointment_time = startApDate
      let res = await this.$http.get(this.$APP_CONFIG.api.appointment(),
        {
          params: this.getAppointmentParams(start, end),
          credentials: true
        })

      this.appointments = res.body
      this.events = [] // reset events

      if (this.viewType === 'daily' || this.viewType === 'weekly' || this.viewType === 'monthly') {
        // Clear events
        var dtParams = {
          clinic_id: this.$guser.user.clinic ? this.$guser.user.clinic.id : null,
          doctor_id: this.$guser.user.doctor ? this.$guser.user.doctor.id : null
        }
        dtParams.start = startApDate
        dtParams.end = endApDate
        if (this.filter_by_doctor && this.filter_by_doctor.value) {
          dtParams.doctor_id = this.filter_by_doctor.value
        }
        if (this.filter_by_specialty && this.filter_by_specialty.value) {
          dtParams.speciality_id = this.filter_by_specialty.value
        }
        let dtListRes = await this.$http.get(this.$APP_CONFIG.api.admin.doctors(), { params: dtParams })
        if (dtListRes && dtListRes.body && dtListRes.body.data) {
          dtListRes.body.data.forEach(doctorData => {
            if (doctorData.available_schedules) {
              doctorData.available_schedules.forEach(sc => {
                var startDt = null
                var endDt = null
                for (let weekDay = 0; weekDay < 7; weekDay++) {
                  let weekDate = start.weekday(weekDay)
                  let dayWStr = weekDate.locale('en').format('ddd').toLowerCase()
                  if (dayWStr === sc.week_day) {
                    startDt = moment(weekDate.format('YYYYMMDD') + ' ' + sc.time_from, 'YYYYMMDD HH:mm:ss')
                    endDt = moment(weekDate.format('YYYYMMDD') + ' ' + sc.time_to, 'YYYYMMDD HH:mm:ss')
                    break
                  }
                }

                if (startDt !== null && endDt !== null) {
                  // event
                  this.events.push({
                    id: sc.doctor_id + '' + startDt + '_' + endDt, // event id
                    resourceId: sc.doctor_id, // map to doctor id
                    title: null,
                    start: startDt.format('YYYY-MM-DDTHH:mm:ss'),
                    end: endDt.format('YYYY-MM-DDTHH:mm:ss'),
                    service_id: null,
                    hn: null,
                    status: 'background',
                    time_slots: sc.time_slots,
                    color: '#00FF00',
                    rendering: 'background'
                  })
                }
              })
            }

            if (doctorData.timeoffs) {
              doctorData.timeoffs.forEach(tf => {
                let startSpl = tf.start_time.split(' ')
                let endSpl = tf.end_time.split(' ')
                let startDt = startSpl.join('T')
                let endDt = endSpl.join('T')

                if (this.viewType === 'monthly') {
                  startDt = startSpl[0]
                  endDt = moment(endSpl[0]).add(1, 'days').format('YYYY-MM-DD')
                }

                // event
                this.events.push({
                  id: tf.doctor_id + '' + startDt + '_' + endDt, // event id
                  resourceId: tf.doctor_id, // map to doctor id
                  title: null,
                  start: startDt,
                  end: endDt,
                  service_id: null,
                  hn: null,
                  status: 'background',
                  color: '#FF0000',
                  rendering: 'background',
                  overlap: true
                })
              })
            }

            let fd = this.doctor_options.find(doctorOption => doctorOption.value === +doctorData.id)
            if (!fd) {
              this.doctor_options.push({
                value: doctorData.id,
                label: (this.$i18n.locale === 'th') ? doctorData.name_th : doctorData.name_en,
                data: doctorData
              })
            }
          })
        }
      }

      this.appointments.forEach(a => {
        let d = a.object.doctor
        if (d) {
          // event as patient
          this.events.push({
            id: a.id, // appointment id
            resourceId: d.id, // map to doctor id
            title: `${a.object.firstname} ${a.object.lastname}`,
            start: a.start.split(' ').join('T'),
            end: a.end.split(' ').join('T'),
            service_id: a.object.service_id,
            hn: a.object.hn,
            patient_status: a.object.patient_status,
            status: a.object.status,
            color: a.color,
            type: 'appointment'
          })
        }

        if (a.object.hn) {
          let fHn = this.hn_options.find(ao => ao.value === a.object.hn)
          if (!fHn) {
            this.hn_options.push({
              value: a.object.hn,
              label: a.object.hn,
              data: a.object
            })
          }
        }
      })

      // if (!this.resourcesAdded) {
      this.resources.forEach(r => {
        this.fc.fullCalendar('addResource', r)
      })
      // this.resourcesAdded = true
      // }

      let filteredEvent = this.filterEvent()

      // this.fc.fullCalendar('removeEvents')
      // this.initedCalendar = true // mark that this calendar was inited
      // callback(filteredEvent)
      /* if (renderedCallback) {
        renderedCallback()
        renderedCallback = null
      } */
      this.processEventLoading = false

      // Clear cache
      jq('.fc-event').remove()

      return filteredEvent
    },
    async processStartup () {
      // setup SMS remark template
      if (this.$guser.user.clinic && this.$guser.user.clinic.remark_templates === null) {
        this.$guser.user.clinic.remark_templates = this.remarkTemplates
        this.templates.remark_templates = this.$guser.user.clinic.remark_templates
      }

      // Load export fields
      this.loadExportFields()
      // Setup all filter
      this.setupFilter()
      // Load init data
      await this.loadInitData()

      // Init calendar if it is the first time
      if (this.show_calendar_view && !this.initedCalendar) {
        // await this.loadAppointments(this.filter_by_status, this.filter_date_type)
        this.setupCalendar()
      } else if (!this.show_calendar_view) {
        await this.loadAppointments(this.filter_by_status, this.filter_date_type)
      } else if (this.show_calendar_view && this.initedCalendar) {
        this.refetchEventsDelay()
      }
    },
    appendRemark (content) {
      let newContent = ''
      if (this.appointment.remark) {
        newContent = this.appointment.remark + content
      } else {
        newContent = content
      }

      this.appointment = Object.assign(this.appointment, {
        remark: newContent
      })
    },
    openRemarkEditor () {
      this.$refs.modal.close()
      this.$refs.remarkModal.open()
    },
    closeRemarkModal () {
      this.$refs.remarkModal.close()
      this.$refs.modal.open()
    },
    updateComment ($event) {
      this.templates.remark_templates = $event
    },
    updateRemarks () {
      let updatedClinic = {
        remark_templates: (this.templates.remark_templates) ? this.templates.remark_templates : []
      }
      this.$http.put(this.$APP_CONFIG.api.admin.clinicme(),
        updatedClinic,
        {headers: { 'content-type': 'application/json' }})
        .then(res => {
          if (res.body.status === 'success') {
            this.$guser.user.clinic.remark_templates = res.body.data.remark_templates
          }
        })
    },
    gotoDate () {
      if (this.date) {
        this.fc.fullCalendar('gotoDate', this.date)
        this.date = null
        this.$refs.dateModal.close()
      } else {
        jq('input.flatpickr-input').focus()
      }
    }
  },
  watch: {
    filter_by_specialties (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.filter_by_specialties = [v[v.length - 1]]
        }
        this.filter_by_specialty = data
      } else {
        this.filter_by_specialty = null
      }
    },
    filter_by_clinics (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.filter_by_clinics = [v[v.length - 1]]
        }
        this.filter_by_clinic = data
      } else {
        this.filter_by_clinic = null
      }
    },
    filter_by_doctors (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.filter_by_doctors = [v[v.length - 1]]
        }
        this.filter_by_doctor = data
      } else {
        this.filter_by_doctor = null
      }
    },
    filter_by_status_list (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.filter_by_status_list = [v[v.length - 1]]
        }
        this.filter_by_status = data
      } else {
        this.filter_by_status = null
      }
    },
    filter_by_services (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.filter_by_services = [v[v.length - 1]]
        }
        this.filter_by_service = data
      } else {
        this.filter_by_service = null
      }
    },
    filter_by_hns (v, old) {
      if (v && v.length > 0) {
        let data = v[v.length - 1]
        if (v.length > 1) {
          this.filter_by_hns = [v[v.length - 1]]
        }
        this.filter_by_hn = data
      } else {
        this.filter_by_hn = null
      }
    },
    filter_searchs (v, old) {
      var valueTimeOut = 500
      if (v && v.length > 0) {
        this.count_search++
        this.filter_search = v
        this.appointments = []
        // Switch view
        // if (this.viewType !== 'list') {
        this.viewType = 'list'
        this.filter_date_type = 'all'
        // }
        setTimeout(() => { this.count_search--; if (this.count_search === 0) { this.getSearch(v, this.filter_by_doctor, this.filter_by_specialty, this.filter_by_status, this.filter_date_type) } }, valueTimeOut)
      } else {
        this.filter_search = null
        this.appointments = []
        setTimeout(() => { this.loadAppointments(this.filter_by_status, this.filter_date_type) }, valueTimeOut)
      }
    },
    filter_by_specialty (v, old) {
      if (v !== old && v !== null) {
        this.filter_by_doctors = []
        if (this.filter_by_doctor &&
            this.filter_by_doctor.data &&
            this.filter_by_doctor.data.specialities &&
            this.filter_by_doctor.data.specialities[0] !== v.value) {
          this.filter_by_doctor = null
        }
      }

      this.filterEvent()
      this.refetchEventsDelay()
    },
    filter_by_doctor (v, old) {
      if (!v && this.viewType === 'weekly') {
        this.switchView('daily')
      } else if (v && this.viewType === 'daily') {
        this.switchView('weekly')
      } else {
        console.log('fetch')
        this.filterEvent()
        this.refetchEventsDelay()
      }
    },
    filter_by_status (v, old) {
      this.filterEvent()
      this.refetchEventsDelay()
    },
    filter_by_service (v, old) {
      this.filterEvent()
      this.refetchEventsDelay()
    },
    filter_by_hn (v, old) {
      this.filterEvent()
      this.refetchEventsDelay()
    },
    filter_date_range (v, old) {
      let dateSplitRange = 2
      let dates = v.split('to')
      if (dates.length === dateSplitRange) {
        let from = dates[0].trim()
        let to = dates[1].trim()
        this.loadAppointments(this.filter_by_status, this.filter_date_type, from, to)
      }
    },
    selected_patient (v, old) {
      if (!v) return
      let p = this.patient_list.find(_p => _p.value === +v.value)
      if (p) {
        // fill the patient form
        this.appointment = Object.assign(this.appointment, {
          firstname: p.data.firstname,
          lastname: p.data.lastname,
          email: p.data.email,
          ehr_patient_id: p.value,
          birthday: p.data.birthday,
          prefix: (p.data.prefix) ? this.prefix_options.find(d => d.value === p.data.prefix) : null,
          hn: p.data.hn,
          id_card: p.data.id_card,
          seen_doctor: 1,
          has_medical_record: 1
        })

        jq('#phone').intlTelInput('setNumber', p.data.phone)
      }
    },
    patient_type (v, old) {
      if (v === 'noexists') {
        // reset the patient option selected
        this.selected_patient = null
        // reset patient data in appointment object
        // this.appointment = Object.assign(this.appointment, {
        //   firstname: '',
        //   lastname: '',
        //   phone: '',
        //   email: ''
        // })
        // jq('#phone').intlTelInput('setNumber', '')
      }
    },
    $route (v, old) {
      this.processStartup()
    }
  },
  mounted () {
    // Phone nuber format input
    jq('#phone').intlTelInput({ nationalMode: true, initialCountry: 'th', utilsScript: '/static/utils.js' })
    this.processStartup()
    this.openNewAppointmentForm(false)
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../assets/base_container";

.calendar-page-wrapper {
  width: 100%;
  background-color: white;
  padding: 1rem;
  border-radius: 5px;

  .fc-unthemed .fc-divider, .fc-unthemed .fc-list-heading td, .fc-unthemed .fc-popover .fc-header {
    background: #f4f7f9;
  }

  .fc-center h2 {
    margin: 0px;
    padding: 0px;
    font-size: 1.2rem;
  }

  .event-filters {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    height: 4rem;

    .event-filt {
      margin-right: 1rem;
    }
  }

  .form-wrapper {
    text-align: left;
  }

  .remove-action {
    float: right;
  }

  .alt-view.active {
    color: black;
    background-color: #ccc;
  }

  .views-wrapper {
    float: right;
  }

  .time-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;

    .switch-time {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: flex-end;
      text-align: center;

      .switch-time-btn {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        text-align: center;
      }
    }
  }

  .event-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 0.5rem;

    .filter-date {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-bottom: 1rem;
      text-align: center;
      transition: visibility 0s, opacity 0.5s linear;

      .flatpickr-wrap{
        width: 100%;
      }
      .btn-group {
        margin-right: 10px;
      }
      .inactive {
        background-color: #eee;
        color: #aaa;
      }
    }
  }

  #filter-date-range.flatpickr-input {
    width: 14rem !important;
    text-align: center;
  }

  .selected-tag + input[type=search] {
    width: 70px !important;
  }

  #patient_list {
    margin-bottom: 0.5rem;
  }

  .search-input {
    width: 300px;
    display: inline-block;
    margin: 0;
    vertical-align: middle;
    position: relative;
  }

  .mobile-menu {
    .search-input {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .event-filters {
    .multiselect.multi-select-form {
      width: 25% !important;
    }
  }
}

.table {
  .status-change {
    margin: 10px;
  }
}

.confirm-btn-group {
  margin: auto 0;
}

.confirm-btn-lg .btn {
  padding: 0.7rem 5rem !important;
}

.status-change-btn {
  padding: 0.4rem 5rem !important;
}

.fc-view, .fc-view>table {
  z-index: 0 !important;
}

.phone-box .intl-tel-input {
  width: 100%;
}

.scheduler-box {
  position: relative;
  display: inline-block;
}

.scheduler-indicator-box {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.6);
  width: 100%;
  height: 100%;
  z-index: 1;
}

.scheduler-indicator {
  margin: 150px auto;
  width: 100px;
  height: 100px;
}

.event-filt-input {
  width: 100%;
}

.fc-toolbar.fc-header-toolbar .fc-center h2 {
  position: relative;
  top: 5px;
}

.date-form {
  width: 60%;
  margin: 0 auto;
}

.date-form .input-group input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.date-form .input-group button {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.form-check-label{
  padding-right: 1.25rem;
  padding-left: 0 !important;
}
.custom-field-wrap{
  padding: 10px 0 10px;
}
.custom-field{
  cursor: pointer;
  color: #20a8d8 !important;
}
.sms-confirm-modal{
  .btn{
    margin-left: 10px;
  }
}
.pagination div {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    color: #ccc !important;
}
.pagination a {
    color: #ccc!important;
    cursor: pointer;
    font-weight: 700;
    text-decoration: underline;
    padding: .3rem;
}
.has-search .form-control-feedback {
    left: 10px;
    color: #ccc;
    position: absolute;
    font-size: 1.25rem;
    margin-top: 0.55rem;
}

.has-search .form-control {
    padding-right: 12px;
    padding-left: 34px;
}
</style>



// WEBPACK FOOTER //
// AppointmentCalendar.vue?9427f55e